export const pinnedGroupHeader = "QQd";
export default {pinnedGroupHeader};